import React from 'react';
import Banner from './Banner';
import HeaderOne from '../../components/header/HeaderOne';
import LeaderBoardList from './leaderBoardList';
import TabbedPage from './TabbedPage';
import { useLocation} from "react-router-dom"
import Footer from '../../components/footer/Footer';

const Leaderboard = () => {

  return (
    <>
      <HeaderOne />
      <main>
        <Banner />
        <TabbedPage/>
        {/* <LeaderBoardList/> */}
      </main>
      <Footer/>
    </>
  );
};

export default Leaderboard;
